// src/pages/ReturnPolicy.js
import React from "react";
import { Container, Typography, Box } from "@mui/material";

const ReturnPolicy = () => {
  return (
    <Container>
      <Box
        sx={{
          position: "relative",
          top: 0,
          left: 0,
          width: "50vw", 
          height:  { xs: "10vh", sm: "15vh", md: "30vh" }, 
          backgroundImage: "url(/return.jpg)",
          backgroundColor: "lavenderblush",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          overflow: "hidden", 
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "black",
          textAlign: "lcenter",
          zIndex: -1,
        }}
      ></Box>
      <Box sx={{ textAlign: "center", mt: 5 }}>
        <Typography variant="h4" gutterBottom>
          Return Policy
        </Typography>
        <Typography variant="body1" paragraph>
          Returns can only be accepted if it is the fault of the crafter. The
          return must be approved by Whimssical Stitches personel and the item
          must be returned within 10 calendar days.
        </Typography>
        <Typography variant="body1" paragraph>
          If you place an order and change your mind before the item is
          completed, you will receive a refund less 20%.
        </Typography>
        <Typography variant="body1" paragraph>
          To initiate a return, please contact our customer service team with
          the order details of the item you wish to return.
        </Typography>
      </Box>
    </Container>
  );
};

export default ReturnPolicy;
